// @flow

import is from 'ramda/src/is';
import { type JSONSchema } from '@catalytic/json-schema-validator-catalytic-web';
import { createValidation } from '../Hook/useValidation';

const isBlob = is(window.Blob);
const isFileSchemaAndBlobValue = (schema?: JSONSchema<>, value?: any) =>
  schema?.refType === 'FILE' && isBlob(value);
const isFileSchemaAndEmptyStringValue = (schema?: JSONSchema<>, value?: any) =>
  schema?.refType === 'FILE' && value === '';

const getErrorMessage = ({
  schema,
  value
}: {
  schema?: JSONSchema<>,
  value?: any
}) => {
  if (
    schema === undefined ||
    // If the value is null or an empty string, we don't care about the error
    // message (like "Must be string"). Our forms will already apply the error
    // styling for required fields and the data type error message is not
    // meaningful to users.
    value === null ||
    value === '' ||
    // Since json-schema-validator considers file blobs to be invalid
    // for file fields and there's no immediate value to supporting them,
    // we skip file blob validation for now.
    isFileSchemaAndBlobValue(schema, value) ||
    // When a file is removed from a file input, the field's value get's
    // set to an empty string. We still want to ignore the schema error
    // and just let the existing form validation handle the required field.
    isFileSchemaAndEmptyStringValue(schema, value)
  ) {
    return;
  }

  const validation = createValidation({ schema, value });
  const error = [...(validation.errors || [])].pop();
  const errorMessage = error?.message;

  return errorMessage;
};

export default getErrorMessage;
